export const SortUpIcon = () => {
  return (
    <svg
      style={{ display: "inline", color: "#aaaaaa" }}
      aria-hidden="true"
      focusable="false"
      data-prefix="fas"
      data-icon="sort-up"
      width={15}
      height={15}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
    >
      <path
        fill="currentColor"
        d="M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
      ></path>
    </svg>
  );
};
